import React, { useEffect, useState } from "react";
import {
	useApproveRestaurant,
	useGetRestaurantSettings,
	useUpdateRestaurantSettings,
} from "../../../queryHooks";
import { approveRestaurantSchema } from "../../../validations";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { useStore } from "../../../zustand/store";
import Slider from "rc-slider";
import SingleStatusToggle from "../../common/singleStatusToggle";
import ErrorsInfo from "./ErrorsInfo";
import { isEmpty } from "lodash";

//  Component starts
const ApproveRestaurant = ({ restaurantId, onCloseModal }) => {
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [approveErrors, setApproveErrors] = useState(false);
	const [checksData, setChecksData] = useState([]);
	const [saveEnable, setSaveEnable] = useState(false);

	const { data: restaurantsSettingsData, refetch } =
		useGetRestaurantSettings(restaurantId);

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: {
			commissionRate: restaurantsSettingsData?.data?.platform_fee_percentage,
			serviceCharge: restaurantsSettingsData?.data?.service_charge_percentage,
			isServiceChargeAllowed:
				!!restaurantsSettingsData?.data?.service_charge_enabled,
			isTipAllowed: !!restaurantsSettingsData?.data?.tips_enabled,
			isServiceChargeTaxable:
				!!restaurantsSettingsData?.data?.service_charge_taxable,
		},
		validationSchema: approveRestaurantSchema,
		onSubmit: (value) => {
			let body = {
				...(restaurantsSettingsData?.data?.platform_fee_percentage !==
					value.commissionRate && {
					platform_fee_percentage: value.commissionRate,
				}),
				...(!!restaurantsSettingsData?.data?.tips_enabled !==
					value.isTipAllowed && { tips_enabled: value.isTipAllowed }),
				...(!!restaurantsSettingsData?.data?.service_charge_enabled !==
					value.isServiceChargeAllowed && {
					service_charge_enabled: value.isServiceChargeAllowed,
				}),
				...(value.isServiceChargeAllowed &&
					!!restaurantsSettingsData?.data?.service_charge_taxable !==
						value.isServiceChargeTaxable && {
						service_charge_taxable: value.isServiceChargeTaxable,
					}),
				...(value.isServiceChargeAllowed &&
					restaurantsSettingsData?.data?.service_charge_percentage !==
						value.serviceCharge && {
						service_charge_percentage: value.serviceCharge,
					}),
			};
			console.log(body);
			if (!isEmpty(body))
				updateRestaurantSettingsAsync({
					restaurantId,
					body,
				});
		},
	});

	const get2PointFloatValue = (val) => {
		if (isNaN(val)) return null;
		return parseFloat(val).toFixed(2);
	};
	const checkForChanges = () => {
		let val =
			get2PointFloatValue(values.commissionRate) !==
				get2PointFloatValue(
					restaurantsSettingsData?.data?.platform_fee_percentage
				) ||
			values.isServiceChargeAllowed !==
				!!restaurantsSettingsData?.data?.service_charge_enabled ||
			get2PointFloatValue(values.serviceCharge) !==
				get2PointFloatValue(
					restaurantsSettingsData?.data?.service_charge_percentage
				) ||
			values.isTipAllowed !== !!restaurantsSettingsData?.data?.tips_enabled ||
			values.isServiceChargeTaxable !==
				!!restaurantsSettingsData?.data?.service_charge_taxable;

		return val;
	};

	useEffect(() => {
		let val = checkForChanges();
		setSaveEnable(val);
	}, [values, restaurantsSettingsData]);

	const {
		mutateAsync: updateRestaurantSettingsAsync,
		error: errorUpdateRestaurantSettings,
		data: dataUpdateRestaurantSettings,
		isLoading: updateRestaurantSettingsLoading,
	} = useUpdateRestaurantSettings();

	useEffect(() => {
		if (dataUpdateRestaurantSettings) {
			if (dataUpdateRestaurantSettings?.status === "success") {
				refetch();
				CS.showSuccessMessage(dataUpdateRestaurantSettings?.message);
				setSaveEnable(false);
			} else if (dataUpdateRestaurantSettings?.status === "fail") {
				CS.showErrorMessage(dataUpdateRestaurantSettings?.message);
			}
		}
	}, [dataUpdateRestaurantSettings]);

	useEffect(() => {
		if (errorUpdateRestaurantSettings) {
			CS.showErrorMessage(
				errorUpdateRestaurantSettings?.response?.data?.message
			);
		}
	}, [errorUpdateRestaurantSettings]);

	const {
		mutateAsync: approveAsync,
		data: approveRestaurantData,
		error: approveRestaurantError,
		isLoading: approveRestaurantLoading,
	} = useApproveRestaurant();

	const handleApprove = () => {
		approveAsync(restaurantId);
	};

	useEffect(() => {
		if (approveRestaurantData) {
			if (approveRestaurantData.status === "success") {
				CS.showSuccessMessage(approveRestaurantData.message);
				onCloseModal();
			} else if (approveRestaurantData.status === "fail") {
				setApproveErrors(true);
				setChecksData(approveRestaurantData?.data);
			}
		}
	}, [approveRestaurantData]);

	useEffect(() => {
		if (approveRestaurantError) {
			if (approveRestaurantError?.response?.data) {
				setApproveErrors(true);
				setChecksData(approveRestaurantError?.response?.data?.data?.checks);
			} else
				CS.showErrorMessage(approveRestaurantError.response?.data?.message);
		}
	}, [approveRestaurantError]);

	useEffect(() => {
		if (!values.isServiceChargeAllowed) {
			let eventTax = {
				target: {
					name: "isServiceChargeTaxable",
					value: !!restaurantsSettingsData?.data?.service_charge_taxable,
				},
			};
			handleChange(eventTax);
			let eventCharge = {
				target: {
					name: "serviceCharge",
					value: restaurantsSettingsData?.data?.service_charge_percentage,
				},
			};
			handleChange(eventCharge);
		}
	}, [values.isServiceChargeAllowed]);

	useEffect(() => {
		setLoading(updateRestaurantSettingsLoading || approveRestaurantLoading);
	}, [updateRestaurantSettingsLoading, approveRestaurantLoading]);

	return (
		<>
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">Approve Restaurant</h5>
				</div>
				{/* <div className="m-2">
					<label style={{ textTransform: "none" }}>
						NOTE:{" "}
						<strong>
							These values cannot be modified once restaurant is approved
						</strong>
					</label>
				</div> */}
				<div className="notification-form modal-body card profile-card password-modal">
					<div className="row">
						<div className="col-md-12">
							<form onSubmit={handleSubmit}>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<div className="d-flex justify-content-between align-items-center">
											<label className="mb-0">Commission Rate(%)</label>
											<input
												className="form-control col-sm-3"
												id="commissionRate"
												name="commissionRate"
												placeholder="Enter commission rate"
												onKeyUp={(e) => {
													e.target.value = Math.abs(e.target.value);
													handleChange(e);
												}}
												value={values.commissionRate}
												type="number"
												onChange={handleChange}
											/>
										</div>
										<Slider
											className="mt-3"
											min={0}
											max={100}
											value={values.commissionRate}
											onChange={(e) => {
												handleChange({
													target: { name: "commissionRate", value: e },
												});
											}}
										/>
										<span className="text-danger d-block">
											{errors.commissionRate && touched.commissionRate
												? errors.commissionRate
												: null}
										</span>
									</div>
									<div className="form-group mb-0">
										<div className="d-flex justify-content-between mb-3 mt-3">
											<label className="mb-0">Enable Tips</label>
											<SingleStatusToggle
												_id={"tip"}
												status={values.isTipAllowed}
												onToggleChange={() => {
													let event = {
														target: {
															name: "isTipAllowed",
															value: !values.isTipAllowed,
														},
													};
													handleChange(event);
												}}
												htmlFor={"tip"}
											/>
										</div>
									</div>
									<div className="form-group mb-0">
										<div className="d-flex justify-content-between align-items-center mb-3 mt-3">
											<label className="mb-0">Enable Service Charge</label>
											<SingleStatusToggle
												_id={"isServiceChargeAllowed"}
												status={values.isServiceChargeAllowed}
												onToggleChange={() => {
													let event = {
														target: {
															name: "isServiceChargeAllowed",
															value: !values.isServiceChargeAllowed,
														},
													};
													handleChange(event);
												}}
												htmlFor={"isServiceChargeAllowed"}
											/>
										</div>
									</div>
									{values.isServiceChargeAllowed ? (
										<>
											<div className="form-group mb-0">
												<div className="d-flex justify-content-between align-items-center">
													<label className="mb-0">Service Charge(%)</label>
													<input
														className="form-control col-sm-3"
														id="serviceCharge"
														name="serviceCharge"
														placeholder="Enter service charge"
														disabled={!values.isServiceChargeAllowed}
														onKeyUp={(e) => {
															e.target.value = Math.abs(e.target.value);
															handleChange(e);
														}}
														value={values.serviceCharge}
														type="number"
														onChange={handleChange}
													/>
												</div>
												<Slider
													className="mt-3 mb-3"
													min={0}
													max={100}
													value={values.serviceCharge}
													onChange={(e) => {
														handleChange({
															target: { name: "serviceCharge", value: e },
														});
													}}
												/>
												<span className="text-danger d-block">
													{errors.serviceCharge && touched.serviceCharge
														? errors.serviceCharge
														: null}
												</span>
											</div>
											<div className="form-group mb-0">
												<div className="d-flex justify-content-between mb-3 mt-3">
													<label className="mb-0">Service Charge Taxable</label>
													<SingleStatusToggle
														_id={"isServiceChargeTaxable"}
														status={values.isServiceChargeTaxable}
														onToggleChange={() => {
															let event = {
																target: {
																	name: "isServiceChargeTaxable",
																	value: !values.isServiceChargeTaxable,
																},
															};
															handleChange(event);
														}}
														htmlFor={"isServiceChargeTaxable"}
													/>
												</div>
											</div>
										</>
									) : null}
								</div>
								<div className="mt-5 text-right">
									<button
										className="btn btn-primary mr-3"
										onClick={handleSubmit}
										disabled={!saveEnable}
										type="button"
									>
										Save Changes
									</button>
									<button
										className="btn btn-primary"
										onClick={handleApprove}
										disabled={saveEnable}
										type="button"
									>
										Approve
									</button>
								</div>
							</form>
						</div>
						{approveErrors && (
							<ErrorsInfo
								data={checksData}
								title={"Restaurant Approval Fail Due To :"}
							/>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default ApproveRestaurant;
